module.exports = __webpack_public_path__ + "img/kf-wx.710bacc3.png";